import { AuthorizedApiBase } from "./authorized-api-base";
import {
  AddMDMSelectedLegalEntityDTO,
  ArchiveSitesDTO,
  CEMClientDTO,
  DocumentTreeResponseDTO,
  FileResponse,
  GetAllSitesFromTrackResponse,
  GetSiteHistoryDTO,
  HQStatusListResponse,
  ItemSyncTrackDto,
  MDMLegalEntityDTO,
  MDMLegalEntityResponse,
  ProblemDetails,
  SiteCreationMessage,
} from "./taxportal-client";

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

export interface GetSitesResponse {
  message: string;
  statusCode: number;
  data: data;
}

export interface PdcSiteLegalEntityMapping {
  siteId: number;
  pdcDuoConfigurations: PdcDuoConfigurations[];
}
export interface PdcSiteLegalEntityMappingResponse {
  statusCode: number;
  message: string;
  data: PdcSiteLegalEntityMapping;
}
export interface PdcDuoConfigurations {
  clientId: number;
  clientName?: string;
  isPdcEnabled: boolean;
  isDuoEnabled?: boolean;
}

export interface data {
  data: siteDetailDTO[];
  totalCount: number;
}
export interface siteDetailDTO {
  appName?: string | undefined;
  created?: string | undefined;
  createdBy?: string | undefined;
  hqSiteId?: number | undefined;
  hqSiteName?: string | undefined;
  id?: string | undefined;
  includeAllEntities?: string | undefined;
  lastModified?: string | undefined;
  lastModifiedBy?: string | undefined;
  masterClientId?: number | undefined;
  requestType?: string | undefined;
  scriptDescription?: string | undefined;
  selectedLegalEntities?: string | null;
  siteCreationTemplatesByScriptId?: string | undefined;
  status?: string | undefined;
  taxYearEndDate?: string | undefined;
  taxYearStartDate?: string | undefined;
  templateId?: number | undefined;
  templateName?: string | undefined;
}
export interface StandardResponse {
  isSuccess?: boolean;
  result?: any | undefined;
  message?: string | undefined;
}
export interface GetSiteCommentsDTO {
  hqSiteId?: number;
  mdmClientId?: number;
  hqClientName?: string | undefined;
  siteComments?: string | undefined;
  updateBy?: string | undefined;
  updateDate?: Date | undefined;
}
export interface TIM_Projects {
  statusCode: number;
  message: string;
  data: TIM_Projects_Data;
}
export interface TIM_Projects_Data {
  statusCode: number;
  message: string;
  data: ProjectsResponse;
}
export interface ProjectsResponse {
  hqsiteid?: number;
  projects?: ProjectDetails[] | undefined;
  totalcount?: number;
}

export interface ProjectDetails {
  id?: number | undefined;
  entityid?: number | undefined;
  entity?: string | undefined;
  projectidmdm?: number | undefined;
  projectdefaultname?: string | undefined;
  projectname?: string | undefined;
  consent7216?: string | undefined;
  taxyear?: number | undefined;
  status?: string | undefined;
  projectcustomname?: string | undefined;
  visibility?: boolean;
  projectpeople?: ProjectPerson[] | undefined;
  haveUnreadMessage?: boolean | undefined;
  haveUnreadNote?: boolean | undefined;
}

export interface ProjectPerson {
  id?: number | undefined;
  name?: string | undefined;
  employeenumber?: string | undefined;
  email?: string | undefined;
  projectidmdm?: number | undefined;
  visibility?: boolean | undefined;
}

export interface MentionableUser {
  id: number;
  name: string;
  email: string;
}

export interface MentionedUser {
  name?: string;
  email?: string;
}
export interface TimResponseOfDeliverableResponse {
  success?: boolean;
  data?: DeliverableResponse | undefined;
  message?: string;
}
export interface DeliverableResponse {
  projectidtim?: number;
  deliverables?: DeliverableDetails[] | undefined;
}

export interface DeliverableDetails {
  id?: number | undefined;
  entityid?: number | undefined;
  entity?: string | undefined;
  projectidmdm?: number | undefined;
  jurisdictionname?: string | undefined;
  form?: string | undefined;
  status?: string | undefined;
  internalduedate?: Date | undefined;
  statutoryduedate?: Date | undefined;
  extended?: string | undefined;
  filingmethod?: string | undefined;
  signers?: DeliverablePersonDto[] | undefined;
  deliverymethod?: string | undefined;
  visibility?: boolean;
}

export interface DeliverablePersonDto {
  id?: number | undefined;
  taskid?: number | undefined;
  name?: string | undefined;
  employeenumber?: string | undefined;
  email?: string | undefined;
  role?: string | undefined;
}

export interface MDMSelectedLegalEntityDTO {
  countryId?: number | undefined;
  countryName?: string | undefined;
  countryIso?: string | undefined;
  masterClientCountryId?: number | undefined;
  masterClientCountryName?: string | undefined;
  masterClientCountryIso?: string | undefined;
  clientId?: number | undefined;
  clientIdText?: string | undefined;
  clientName?: string | undefined;
  isActive?: boolean | undefined;
  masterClientId?: number | undefined;
  masterClientName?: string | undefined;
  masterClientIdText?: string | undefined;
  hqSiteId?: number | undefined;
  mdmClientId?: number | undefined;
  suppressFolderCreation?: boolean | undefined;
  suppressDropdown?: boolean | undefined;
  suppressProjectStatus?: boolean | undefined;
  userName?: string | undefined;
  isRemoved?: boolean | false;
}
export interface CEMHQClientMappingDTO {
  id?: number;
  mdmClientId?: number;
  clientName?: string | undefined;
  hqSiteId?: number;
  hqClientName?: string | undefined;
  appName?: string | undefined;
}

export interface CEMHQClientDTO {
  mdmClientId?: number;
  clientName?: string | undefined;
  hqSiteId?: number;
  hqClientName?: string | undefined;
  appName?: string | undefined;
  siteConfig?: string | undefined;
}

export interface PdcConfiguration {
  hqSiteId?: number;
  isPDCEnabled?: boolean;
}

export interface PdcConfigurationUpdateResult {
  key?: boolean;
  value?: string;
}

export interface GetMDMEntityListDTO {
  masterClientId?: number | undefined;
  clientName?: string | undefined;
  clientId?: number | undefined;
}

export interface GetMDMEntityListResponse {
  entities: GetMDMEntityListDTO[];
  isAllEntitySelected: boolean | false;
  exclude7216Consent: boolean | false;
  isPDCEnabled: boolean | false;
}
export interface GetSiteSettingsDTO {
  id: string | number;
  setting: string;
  description: string;
  value: string;
  actionDisplayName: string;
  actionUrl: string;
}
export interface HQSitesSettingDTO {
  id?: number;
  value?: string | undefined;
  setting?: string | undefined;
  description?: string | undefined;
  actionDisplayName?: string | undefined;
  actionUrl?: string | undefined;
}
export interface CreateSitesSettingIdDTO {
  id?: number | undefined;
}
export interface SiteCreationTemplatesDto {
  id?: number;
  sitename?: string | undefined;
}
export interface SiteCreationRequestMessage {
  request?: RequestData | undefined;
  typeMessage?: string | undefined;
  stepNumber?: number | undefined;
  processExceutionDetailId?: string | undefined;
  retryStep?: number | undefined;
  eventType?: ServiceBusEnum;
  isTriggeredManually?: boolean;
}
export interface RequestData {
  user?: string | undefined;
  id?: string | undefined;
  requestType?: string | undefined;
  appName?: string | undefined;
  scriptId?: string | undefined;
  templateId?: number | undefined;
  statusId?: string | undefined;
  hqSiteId?: number | undefined;
  siteName?: string | undefined;
  masterClientId?: number | undefined;
  taxYearStartDate?: Date | undefined;
  taxYearEndDate?: Date | undefined;
  selectedLegalEntities?: (number | undefined)[] | undefined;
  includeAllEntities?: string | undefined;
  filesProcessValidationId?: string | undefined;
  isTestSite?: boolean | undefined;
  isProspect?: boolean;
}

export interface IsheetReportDto {
  siteId?: number;
  totalRecords?: number;
  lastModifiedDate?: Date | undefined;
  lastModifiedUser?: string | undefined;
}

export interface GetSiteCommentsDto {
  created?: Date;
  createdBy?: string | undefined;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  hqSiteId?: number | undefined;
  siteComment?: string | undefined;
  userName?: string | undefined;
}

export interface DocumentTreeDto {
  siteid?: string | undefined;
  files?: ItemDto[] | undefined;
}

export interface ItemDto {
  uniqueId?: string | undefined;
  id?: string | undefined;
  text?: string | undefined;
  icon?: string;
  expanded?: boolean;
  parentId?: string | undefined;
  items?: ItemDto[];
  itemPath?: string | undefined;
  itemType?: string | undefined;
  disabled?: boolean;
  showMoreLimit?: number;
  level?: number;
  hasItems?: boolean;
  year?: number;
  securitySummary?: string | undefined;
}

export interface ISheetItemRedirectRequest {
  siteId: number;
  iSheetName: string;
  filters: ColumnFilter[];
}

export interface ColumnFilter {
  columnName: string;
  filterValue?: string; // ? = nullable
}

export enum ServiceBusEnum {
  SITE_CREATION = 101,
  SYNC_CEM = 102,
  SYNC_CEM_HQ = 103,
  SITE_ADMIN_ACCESS = 104,
  IR_CHOICES = 105,
  EXTERNAL_FOLDER_CREATION = 106,
  SYNC_IR = 107,
  PROVIDE_APP_ACCESS = 108,
  UPDATE_FILES_METADATA = 109,
  UPDATE_FILES_LOCATION = 110,
  DM_CHOICES = 111,
  INTERNAL_FOLDER_CREATION = 112,
  IM_SYNC_RULES = 114,
  CREATE_EXTERNAL_USER = 115,
  SYNC_MDM = 116,
  SYNC_PS = 117,
  DOWNLOAD_FILES = 118,
  DOWNLOAD_ATTACHMENT_IR = 184,
  UPLOAD_FILES = 119,
  UPLOAD_ATTACHMENT_IR = 185,
  UPDATE_IR_METADATA = 120,
  SEND_FILES_TO_DUO = 121,
  IR_ROLLOVER = 122,
  FILES_ROLLOVER = 123,
  SYNC_ISHEET = 124,
  SYNC_CONSENT = 125,
  FOLDER_CREATION_SPECIFIC = 126,
  SYNC_AD = 127,
  SYNC_ENTITY_ISHEET = 128,
  PROVIDE_APP_LEVEL_ACCESS = 129,
  UPDATE_AND_MOVE_FILES = 130,
  SYNC_SITE_SETTINGS = 131,
  CREATE_EXTERNAL_USER_CS = 132,
  REMOVE_EXTERNAL_USER = 133,
  CHECK_EXTERNAL_USER_STATUS = 134,
  IR_ASSIGNED_TO_SEND_EMAIL = 135,
  SYNC_ASSIGNMENT = 136,
  REMOVE_ENTITY_FROM_SITE = 137,
  CREATE_EXTERNAL_USER_THIRD_PARTY = 138,
  ADD_ENTITY_TO_SITE = 139,
  REMOVE_FOLDER_RESTRICTION = 140,
  PUSH_ORG_TO_ISHEET = 141,
  INTERNAL_USER_ASSIGNMENT = 142,
  CS_ISHEET_DEFAULT_DATA = 144,
  REMOVE_SUPPRESSED_ENTITIES = 145,
  PROVIDE_USERGROUP_ACCESS = 146,
  INTERNAL_USER_ASSIGNMENT_CS = 147,
  UPDATE_SHEET_SETTINGS = 148,
  SYNC_CONTROVERSY_TRACKER = 149,
  SITE_CREATION_VERIFY = 150,
  USAGE_METRICS_REPORT = 151,
  TESS_ASSIGNMENT = 152,
  UPDATE_CUSTOM_GROUPS = 155,
  CONTROVERSY_TRACKER = 156,
  GLOBAL_TAX_SYNC = 157,
  TESS_ISHEET_ASSIGNMENT = 158,
  CONTROVERSY_TRACKER_USERS_SYNC = 159,
  MEMBER_FIRM_CS = 161,
  RUN_SITES_API = 162,
  TESS_IUR_ACCESS = 163,
  CONTROVERSY_TRACKER_DELETED_RECORDS_SYNC = 164,
  POPULATE_MEMBERFIRM_DROPDOWN = 165,
  CUSTOM_PERMISSION_PER_ENTITY = 166,
  CUSTOM_PERMISSION_GROUP_CREATION = 167,
  CUSTOM_PERMISSION_GROUP_DELETION = 168,
  SYNC_MDM_PROJECT = 169,
  SYNC_MDM_PHASE = 170,
  SYNC_IMANAGE_WORKSPACE_PER_SITE = 171,
  MDM_SYNC_LEAD_NAMES = 172,
  ROLLOVERS_CS_FILES = 174,
  ROLLOVERS_CS_INFORMATIONREQUEST = 175,
  CUSTOM_VIEW_PERMISSION_PER_ENTITY = 176,
  ROLLOVERS_CS_PROJECTTRACKING = 177,
  CONTROVERSY_TRACKER_LEGACY_RECORD_SYNC = 178,
  UPDATE_K1TRACKER_ENTITY_DROPDOWN = 179,
  UPDATE_DELIVERABLES_ENTITY_DROPDOWN = 180,
  RUN_ISHEET_TRIGGER_API = 181,
  CopyFiles_HighQ_ToImanage = 182,
  UploadFiles_HighQ_ToImanage = 183,
  DOWNLOAD_IR_ATTACHMENT = 184,
  UPLOAD_IR_ATTACHMENT = 185,
  UPDATE_CENTRAL_CONTROVERSY_TRACKER_ENTITIES = 186,
  UPDATE_DOCUMENT_COUNT = 188,
  CONTROVERSY_TRACKER_RECORDS_SYNC = 189,
  SYNC_IDM_USER = 194,
  UPDATE_VIEWS = 154,
  ROLLOVER_MICRO_SERVICE = 206,
}
export interface ResultAllUsersOfUserGroups {
  id?: string | undefined;
  name?: string | undefined;
  email?: string | undefined;
  type?: string | undefined;
  hasActiveMembership?: boolean;
}

export interface HQCreateUserRequestDTO {
  itemId?: number | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  action?: string | undefined;
  email?: string | undefined;
  approvedBy?: string | undefined;
  approvedDateTime?: string | undefined;
  registrationStatus?: string | undefined;
  siteAccessStatus?: string | undefined;
  resendStatus?: string | undefined;
  removalStatus?: string | undefined;
  approval?: string | undefined;
  siteName?: string | undefined;
  userGroup?: string | undefined;
  userGroups?: string[];
  organization?: string | undefined;
  role?: string | undefined;
  status?: string | undefined;
  removalDate?: string | undefined;
  insightReportAccess?: string | undefined;
  welcomeEmail?: string | undefined;
  masterClientNumber?: string | undefined;
  clientNameUS?: string | undefined;
  clientNameUSI?: string | undefined;
  assignmentDate?: string | undefined;
  appName?: string | undefined;
}

export interface HQDocumentMetadataRequestDTO {
  entity?: string | undefined;
  pbcStorageLocation?: string | undefined;
  folder?: string | undefined;
  folderPath?: string | undefined;
  file?: string | undefined;
  fileName?: string | undefined;
  itemId?: string | undefined;
  columnId?: string | undefined;
  notes?: string | undefined;
  informationRequestStatus?: string | undefined;
  fileExtension?: string | undefined;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
  downloaded?: string | undefined;
  uploaded?: string | undefined;
  entityId?: number | undefined;
  copyToImanage?: string | undefined;
  informationRequestId?: string | undefined;
  attachmentId?: string | undefined;
  copyStatus?: string | undefined;
  lockStatus?: string | undefined;
  iManageLink?: string | undefined;
  copiedfromiManage?: string | undefined;
  fileStatus?: string | undefined;
  keepAfterRollover?: string | undefined;
}

export interface ServiceMessage {
  correlationId?: string | undefined;
  siteId?: number | undefined;
  mdmClientId?: number | undefined;
  isheetId?: number | undefined;
  itemId?: number | undefined;
  year?: number | undefined;
  newTaxYear?: number | undefined;
  isForceUpdate?: boolean | undefined;
  userName?: string | undefined;
  eventType?: ServiceBusEnum;
  roleId?: string | undefined;
  roleName?: string | undefined;
  externalUserType?: string | undefined;
  applicationGroupType?: string | undefined;
  clientName?: string | undefined;
  settingsIds?: number[] | undefined;
  isheetType?: string | undefined;
  appName?: string | undefined;
  processTrackId?: number | undefined;
  userOfUserGroupDictionary?: { [key: string]: ResultAllUsersOfUserGroups[] } | undefined;
  userEmailsOfUserGrp?: string[] | undefined;
  usageMetricsType?: string | undefined;
  addResponse?: HQCreateUserRequestDTO[] | undefined;
  removeResponse?: HQCreateUserRequestDTO[] | undefined;
  itemDMFiles?: HQDocumentMetadataRequestDTO[] | undefined;
  fileIds?: string[] | undefined;
  isTriggerFromScheduler?: boolean | undefined;
  siteComments?: string | undefined;
  IsForceUpdate?: boolean | undefined;
  siteCommentSource?: "UpgradeSite" | "CreateandSetupSites";
}

export interface GetAllSitesResponse {
  offset?: number;
  limit?: number;
  totalCount?: number;
  data?: GetAllSitesInfoDTO[] | undefined;
}
export interface GetAllSitesInfoDTO {
  id?: number | undefined;
  hqSiteId?: number | undefined;
  mdmClientId?: number | undefined;
  clientName?: string | undefined;
  hqClientName?: string | undefined;
  siteCreatedBy?: string | undefined;
  siteCreated?: Date | undefined;
  siteLastModified?: Date | undefined;
  appName?: string | undefined;
  trackId?: number | undefined;
  type?: string | undefined;
  lastModified?: Date | undefined;
  lastModifiedBy?: string | undefined;
  status?: string | undefined;
  message?: string | undefined;
  jobId?: string | undefined;
  templateName?: string | undefined;
}

export enum SyncTypeEnum {
  SYNC_ASSIGNMENT = 101,
  TASK_TEMPLATE = 102,
  IR_CHOICES = 103,
  EXTERNAL_FOLDER_CREATION = 104,
  CREATE_FOLDER_INTERNAL = 105,
  UPDATE_FILES_METADATA = 109,
  UPDATE_FILES_LOCATION = 110,
  DM_CHOICES = 111,
  DOWNLOAD_FILES = 112,
  DOWNLOAD_ATTACHMENT_IR = 184,
  SITE_ADMIN_ACCESS = 113,
  UPLOAD_FILES = 114,
  UPLOAD_ATTACHMENT_IR = 185,
  UPDATE_IR_METADATA = 115,
  SEND_FILES_TO_DUO = 116,
  SYNC_PS = 117,
  SYNC_IR = 118,
  UPDATE_AND_MOVE_FILES = 119,
  ROLLOVER_IR = 122,
  FILES_ROLLOVER = 123,
  SYNC_AD = 127,
  SYNC_ENTITY_ISHEET = 128,
  SYNC_SITE_SETTINGS = 131,
  SYNC_MDM = 132,
  CREATE_EXTERNAL_USER = 133,
  CREATE_EXTERNAL_USER_CS = 134,
  REMOVE_EXTERNAL_USER = 135,
  CHECK_EXTERNAL_USER_STATUS = 136,
  CLIENT_LEVEL_ROLE_ASSIGN = 137,
  CREATE_EXTERNAL_USER_THIRD_PARTY = 138,
  SYNC_CEM = 139,
  SITE_CREATION = 140,
  REMOVE_FOLDER_RESTRICTION = 141,
  PUSH_ORG_TO_ISHEET = 142,
  INTERNAL_USER_ASSIGNMENT = 143,
  CS_ISHEET_DEFAULT_DATA = 144,
  SYNC_ISHEET = 145,
  PROVIDE_USERGROUP_ACCESS = 146,
  INTERNAL_USER_ASSIGNMENT_CS = 147,
  SYNC_CONTROVERSY_TRACKER = 149,
  USAGE_METRICS_REPORT = 151,
  TESS_ASSIGNMENT = 152,
  UPDATE_CUSTOM_GROUPS = 155,
  CONTROVERSY_TRACKER = 156,
  TESS_ISHEET_ASSIGNMENT = 158,
  CONTROVERSY_TRACKER_USERS_SYNC = 159,
  SYNC_CEM_HQ = 160,
  MEMBER_FIRM = 161,
  RUN_SITES_API = 162,
  TESS_IUR_ACCESS = 163,
  CONTROVERSY_TRACKER_DELETED_RECORDS_SYNC = 164,
  POPULATE_MEMBERFIRM_DROPDOWN = 165,
  UPDATE_PI_METADATA = 166,
  CUSTOM_PERMISSION_GROUP_CREATION = 167,
  CUSTOM_PERMISSION_GROUP_DELETION = 168,
  SYNC_MDM_PROJECT = 169,
  SYNC_MDM_PHASE = 170,
  SYNC_IMANAGE_WORKSPACE_PER_SITE = 171,
  MDM_SYNC_LEAD_NAMES = 172,
  ROLLOVERS_CS_FILES = 174,
  ROLLOVERS_CS_INFORMATIONREQUEST = 175,
  ROLLOVERS_CS_PROJECTTRACKING = 177,
  CONTROVERSY_TRACKER_LEGACY_RECORD_SYNC = 178,
  UPDATE_K1TRACKER_ENTITY_DROPDOWN = 179,
  UPDATE_DELIVERABLES_ENTITY_DROPDOWN = 180,
  RUN_ISHEET_TRIGGER_API = 181,
  CopyFiles_HighQ_ToImanage = 182,
  UPLOADFILES_HIGHQ_TOIMANAGE = 183,
  DOWNLOAD_IR_ATTACHMENT = 184,
  UPLOAD_IR_ATTACHMENT = 185,
  UPDATE_CENTRAL_CONTROVERSY_TRACKER_ENTITIES = 186,
  REMOVE_ENTITY_FROM_SITE = 187,
  UPDATE_DOCUMENT_COUNT = 188,
  UPDATE_VIEWS = 154,
  SYNC_INFORMATION_REQUEST_ISHEET = 189,
  SYNC_DOCUMENT_METADATA_ISHEET = 190,
  SYNC_FOLDER_METADATA_ISHEET = 191,
  CONTROVERSY_TRACKER_RECORDS_SYNC = 193,
  SYNC_IDM_USER = 194,
}

export interface MessageResultDto {
  message?: string | undefined;
  success?: boolean;
}

export interface ProjectsCustomizationStatusRequestDto {
  hqSiteId?: number;
  projectsCustomizationSatus?: ProjectsCustomizationStatusUpdateDto[];
}
export interface ProjectsCustomizationDataRequestDto {
  hqSiteId?: number;
  projectsCustomizationDatas?: ProjectsCustomizationDataDto[];
}

export interface TimProjectStatusNoteRequestDto {
  note?: string | undefined;
  created?: Date;
  modified?: Date;
}

export interface ProjectsCustomizationDataDto {
  projectIdMDM?: number;
  projectCustomName?: string | undefined;
  isVisible?: boolean | undefined;
  hidealldeliverables?: boolean | undefined;
  hideallentities?: boolean | undefined;
  entitiesToHide?: number[] | undefined;
  deliverablesToHide?: number[] | undefined;
  engamentManagersToHide?: string[] | undefined;
  notes?: string | undefined;
}
export interface ProjectsCustomizationStatusUpdateDto {
  id?: string;
  customStatus?: string | undefined;
  description?: string | undefined;
  isVisible?: boolean | undefined;
}

export interface TimResponseOfTimProjectMessagesResponse {
  success?: boolean;
  data?: TimProjectMessagesResponse | undefined;
  message?: string;
}

export interface TimProjectMessagesResponse {
  hqSiteId?: number;
  projectIdMdm?: number;
  messages?: TimProjectMessage[] | undefined;
}

export interface NotificationDetailResponse {
  hqSiteId?: number;
  projectIdMdm?: number;
  statusNote?: NotificationDetail;
  message?: NotificationDetail;
}

export interface NotificationDetail {
  created?: Date;
  user?: string;
}
export interface TimResponseOfListOfTaggedUser {
  success?: boolean;
  data?: TaggedUser[] | undefined;
  message?: string;
}
export interface TimProjectMessage {
  message?: string;
  created?: Date;
  user?: string;
  userEmail?: string;
  userType?: string;
}
export interface TaggedUser {
  email?: string;
  name?: string;
}

export interface TimProjectMessageRequest {
  hqSiteId?: number;
  projectIdMdm?: number;
  message?: string;
  created?: Date;
  modified?: Date;
  taggedUsers?: MentionedUser[];
  projectName?: string;
  entity?: string;
}

export interface ProjectSettingDTO {
  id?: string;
  property?: string | undefined;
  value?: string | undefined;
  isactive?: boolean;
  created?: Date;
  createdby?: string | undefined;
  lastmodified?: Date | undefined;
  lastmodifiedby?: string | undefined;
}

export interface ProjectsCustomizationStatusDto {
  id?: string;
  appName?: string | undefined;
  hqSiteId?: number;
  appOrigin?: string | undefined;
  status?: string | undefined;
  customStatus?: string | undefined;
  description?: string | undefined;
  isVisible?: boolean | undefined;
}

export interface TriggerUserAssignmentRequest {
  siteId?: number;
  mdmClientId?: number;
  userName?: string;
}

export interface TimResponseOfEntitiesResponse {
  success?: boolean;
  data?: EntitiesResponse | undefined;
  message?: string;
}
export interface TimResponseOfTimTasksResponse {
  success?: boolean;
  data?: TimTasksResponse | undefined;
  message?: string;
}
export interface TimTasksResponse {
  hqsiteid?: number;
  hiddentasks?: number[];
  tasks?: TimTaskResponseDto[] | undefined;
  totalcount?: number;
}
export interface TimTaskResponseDto {
  taskid?: number;
  projectidmdm?: number;
  projectidtim?: number;
  type?: string | undefined;
  projectentity?: string | undefined;
  entity?: string | undefined;
  project?: string | undefined;
  stage?: string | undefined;
  phase?: string | undefined;
  nearestduedate?: Date | undefined;
  Task?: string | undefined;
  AssignedTo?: string | undefined;
  Visibility?: string | undefined;
  lastupdated?: string | undefined;
  lastupdatedby?: Date | undefined;
  IsHiddenProject? : boolean | undefined;
}
export interface TimTasksFilterRequest {
  clientIds?: number[];
  taskEntitiesId?: number[];
  projectNames?: string[];
  ProjectIdsMDM?: number[];
  phaseName?: string[];
  TaskNames?: string[];
}
export interface TimTaskUpdateRequest {
  tasks?: TaskUpdateRequest[] | undefined;
}

export interface TaskUpdateRequest {
  taskId: number;
  status?: string | undefined;
  internalDueDate?: string | undefined;
  assignedEmployeeNumber?: string | undefined;
  assigned?: string | undefined;
  assignedEmail?: string | undefined;
  budgetedHours?: number | undefined;
  notes?: string | undefined;
  rush?: boolean | undefined;
  deliverables?: number[] | undefined;
  sendToShelf?: boolean | undefined;
}
export interface EntitiesResponse {
  projectidtim?: number;
  entities?: EntityDetails[] | undefined;
  totalcount?: number;
}
export interface EntityDetails {
  masterclientandclientid?: string | undefined;
  entityid?: number;
  entity?: string | undefined;
  imanagelink?: string | undefined;
  consent7216?: string | undefined;
  legalentitytype?: string | undefined;
  visibility?: boolean;
}

export interface TimResponseOfObject {
  success?: boolean;
  data?: ProjectSettingDTO;
  message?: string;
}

export interface TimResponseGenericObject<T> {
  success?: boolean;
  data?: T;
  message?: string;
}

export interface ProjectFilter {
  id: number;
  name: string;
}

export interface TimResponseOfListOfProjectFilter {
  success: boolean;
  data: ProjectFilter[] | undefined;
  message: string;
}
export class BulkSiteCretionServiceClient extends AuthorizedApiBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  /* Bulk Site Creation micro service integration Start */

  taxPortal_CancelSiteRequests(email: string, payload: any) {
    let url_ = `${this.baseUrl}/api/v1/SiteCreation/DeleteSite`;
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(payload);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        userName: email,
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxPortal_CancelSiteRequests(_response);
      });
  }

  protected processtaxPortal_CancelSiteRequests(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_RolloverNow(message: any): Promise<string> {
    if (message === undefined || message === null) throw new Error("The parameter 'message' must be defined.");
    let url_ =
      this.baseUrl + "/api/v1/TopicPublish/" + ServiceBusEnum.ROLLOVER_MICRO_SERVICE + "/InsertServiceBusTopicMessage";

    let options_: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(message),
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxPortal_ResponseAsString(_response);
      });
  }

  protected processtaxPortal_ResponseAsString(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_UploadExcel(payload: FormData, userEmail: string) {
    let url_ = `${this.baseUrl}/api/v1/FileProcess/ValidateExcelForSiteCreation?`;
    if (userEmail === null) throw new Error("The parameter 'userEmail' cannot be null.");
    else if (userEmail !== undefined) url_ += "userName=" + encodeURIComponent("" + userEmail) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = payload;
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxPortal_UploadExcel(_response);
      });
  }

  protected processtaxPortal_UploadExcel(response: Response) {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_GetFileProcessValidationGrid() {
    let url_ = this.baseUrl + "/api/v1/FileProcess/GetFileProcessValidationDetails";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.process_GetFileProcessValidationGrid(_response);
      });
  }

  protected process_GetFileProcessValidationGrid(response: Response) {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSitesResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSitesResponse>(null as any);
  }

  taxPortal_GetSitesGridData(
    offset: number | undefined,
    limit: number | undefined,
    appName: string
  ): Promise<GetSitesResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/GetGridData?";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.process_GetSitesGridData(_response);
      });
  }

  taxPortal_GetSitesGridDataBySearch(
    appName: string,
    limit: number | undefined,
    offset: number | undefined,
    searchTerm: any
  ): Promise<GetSitesResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/GetGridData?";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (searchTerm !== undefined && searchTerm !== null && searchTerm !== "")
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.process_GetSitesGridData(_response);
      });
  }

  protected process_GetSitesGridData(response: Response): Promise<GetSitesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSitesResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSitesResponse>(null as any);
  }

  taxportal_GetProcessExecutionDetails(siteId: string | null) {
    let url_ = this.baseUrl + "/api/v1/ProcessExecution/";
    if (siteId === undefined) throw new Error("The parameter 'id' must be defined.");
    if (siteId !== null) url_ += encodeURIComponent("" + siteId) + "/process-execution-details";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxportal_GetProcessExecutionDetailsStatus(_response);
      });
  }

  protected processtaxportal_GetProcessExecutionDetailsStatus(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<any>(null as any);
  }

  taxportal_GetSubProcessExecutionDetails(id: string | null) {
    let url_ = this.baseUrl + "/api/v1/ProcessExecution/";
    if (id === undefined) throw new Error("The parameter 'id' must be defined.");
    if (id !== null) url_ += encodeURIComponent("" + id) + "/sub-process-execution-details";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxportal_GetSubProcessExecutionDetails(_response);
      });
  }

  taxportal_retryStep(id: string | null, payload: any, userEmail: string) {
    let url_ = this.baseUrl + "/api/v1/RetryStep/RetryStep/";
    if (id === undefined) throw new Error("The parameter 'id' must be defined.");
    if (id !== null) url_ += encodeURIComponent("" + id) + "?userName=" + userEmail;
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(payload);
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return _response;
      });
  }

  protected processtaxportal_GetSubProcessExecutionDetails(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<any>(null as any);
  }

  taxportal_DownloadFileWithRejectedRecords(id: string): Promise<ArrayBuffer> {
    let url_ = this.baseUrl + "/dl/v1/FileProcess/DownloadFileWithRejectedRecords?id=";
    if (id === undefined) throw new Error("The parameter 'id' must be defined.");
    if (id !== null) url_ += encodeURIComponent("" + id) + "?";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxportal_DownloadFileWithRejectedRecords(_response);
      });
  }

  protected processtaxportal_DownloadFileWithRejectedRecords(response: Response): Promise<ArrayBuffer> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.arrayBuffer().then((arrayBuffer) => {
        return arrayBuffer;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ArrayBuffer>(null as any);
  }

  taxportal_DownloadTemplate() {
    let url_ = this.baseUrl + "/dl/v1/FileProcess/DownloadTemplate";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return _response;
      });
  }

  /* Bulk Site Creation micro service integration End */

  /* Create Sites Api start */

  taxPortal_ArchiveSites(sites: ArchiveSitesDTO, signal?: AbortSignal): Promise<StandardResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/archiveSites";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(sites);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ArchiveSites(_response);
      });
  }

  protected processTaxPortal_ArchiveSites(response: Response): Promise<StandardResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as StandardResponse);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<StandardResponse>(null as any);
  }

  taxPortal_UnarchiveSites(sites: ArchiveSitesDTO, signal?: AbortSignal): Promise<HQStatusListResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/Unarchive";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(sites);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UnarchiveSites(_response);
      });
  }

  protected processTaxPortal_UnarchiveSites(response: Response): Promise<HQStatusListResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQStatusListResponse);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQStatusListResponse>(null as any);
  }

  highQ_UpdateSiteNameWithClientId(
    siteIds: number[],
    appName: string,
    userName: string,
    signal?: AbortSignal
  ): Promise<string[]> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/addClientId?";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");
    const obj = { siteIds: siteIds, userName: userName, appName: appName };
    const content_ = JSON.stringify(obj);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_UpdateSiteNameWithClientId(_response);
      });
  }

  protected processHighQ_UpdateSiteNameWithClientId(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string[]>(null as any);
  }

  highQ_GetSiteFromTrack(
    status: string | null | undefined,
    appName: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSitesFromTrackResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/siteTrack?";
    if (status !== undefined && status !== null) url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetSiteFromTrack(_response);
      });
  }

  protected processHighQ_GetSiteFromTrack(response: Response): Promise<GetAllSitesFromTrackResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesFromTrackResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesFromTrackResponse>(null as any);
  }

  highQ_GetSiteFromTrackSearch(
    status: string | null | undefined,
    searchTerm: string | null | undefined,
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSitesFromTrackResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/siteTrackSearch?";
    if (status !== undefined && status !== null) url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetSiteFromTrackSearch(_response);
      });
  }

  protected processHighQ_GetSiteFromTrackSearch(response: Response): Promise<GetAllSitesFromTrackResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesFromTrackResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesFromTrackResponse>(null as any);
  }

  taxPortal_CreateSites(messages: SiteCreationMessage[], signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/CreateSite";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_CreateSites(_response);
      });
  }

  protected processTaxPortal_CreateSites(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  mDM_AddSelectedLegalEntities(entities: AddMDMSelectedLegalEntityDTO[], signal?: AbortSignal): Promise<number[]> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/client/addlegalEntities";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(entities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_AddSelectedLegalEntities(_response);
      });
  }

  protected processMDM_AddSelectedLegalEntities(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(null as any);
  }

  mdm_SyncMdmProjectsOrPhases(
    siteId: number | undefined,
    syncProcess: string | undefined,
    userName: string | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/Mdm/SyncMdmProjectsOrPhases?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (syncProcess === null) throw new Error("The parameter 'syncProcess' cannot be null.");
    else if (syncProcess !== undefined) url_ += "syncProcess=" + encodeURIComponent("" + syncProcess) + "&";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMdm_SyncMdmProjectsOrPhases(_response);
      });
  }

  protected processMdm_SyncMdmProjectsOrPhases(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  highQ_ExportToExcelForManageSite(
    appName: string | undefined,
    status: string | null | undefined,
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/dl/v1/SiteCreation/ExportToExcelForManageSite?";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (status !== undefined && status !== null) url_ += "status=" + encodeURIComponent("" + status) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_ExportToExcelForManageSite(_response);
      });
  }

  protected processHighQ_ExportToExcelForManageSite(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  taxPortal_GetSiteHistory(
    siteId: number | null | undefined,
    siteName: string | undefined,
    signal?: AbortSignal
  ): Promise<GetSiteHistoryDTO[]> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/GetSiteHistory?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (siteName === null) throw new Error("The parameter 'siteName' cannot be null.");
    else if (siteName !== undefined) url_ += "siteName=" + encodeURIComponent("" + siteName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetSiteHistory(_response);
      });
  }

  protected processTaxPortal_GetSiteHistory(response: Response): Promise<GetSiteHistoryDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSiteHistoryDTO[]);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSiteHistoryDTO[]>(null as any);
  }

  siteSetUp_CreateSiteVerify(
    appName: string,
    messages: SiteCreationMessage[] | undefined,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/siteSetUp/createSiteVerify/{appName}";
    if (appName === undefined || appName === null) throw new Error("The parameter 'appName' must be defined.");
    url_ = url_.replace("{appName}", encodeURIComponent("" + appName));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteSetUp_CreateSiteVerify(_response);
      });
  }

  protected processSiteSetUp_CreateSiteVerify(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Get Legal Entities by Master Client
   * @param taxYear (optional)
   */
  mDM_GetMDMLegalEntities(mdmClientId: number, taxYear: number | null | undefined, signal?: AbortSignal): Promise<any> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/client/{mdmClientId}/legalEntities?";
    if (mdmClientId === undefined || mdmClientId === null)
      throw new Error("The parameter 'mdmClientId' must be defined.");
    url_ = url_.replace("{mdmClientId}", encodeURIComponent("" + mdmClientId));
    if (taxYear !== undefined && taxYear !== null) url_ += "taxYear=" + encodeURIComponent("" + taxYear) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_GetMDMLegalEntities(_response);
      });
  }

  protected processMDM_GetMDMLegalEntities(response: Response): Promise<MDMLegalEntityResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MDMLegalEntityResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MDMLegalEntityResponse>(null as any);
  }

  mDM_SyncLegalEntitiesConsent(
    mdmClientId: number,
    year: number | null | undefined,
    siteId: number | null | undefined,
    signal?: AbortSignal
  ): Promise<MDMLegalEntityDTO[]> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/client/{mdmClientId}/syncLegalEntitiesConsent?";
    if (mdmClientId === undefined || mdmClientId === null)
      throw new Error("The parameter 'mdmClientId' must be defined.");
    url_ = url_.replace("{mdmClientId}", encodeURIComponent("" + mdmClientId));
    if (year !== undefined && year !== null) url_ += "year=" + encodeURIComponent("" + year) + "&";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_SyncLegalEntitiesConsent(_response);
      });
  }

  protected processMDM_SyncLegalEntitiesConsent(response: Response): Promise<MDMLegalEntityDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MDMLegalEntityDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MDMLegalEntityDTO[]>(null as any);
  }

  highQ_GetConsentedTaxYear(siteId: number | undefined, signal?: AbortSignal): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/GetConsentedTaxYear?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId);
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetConsentedTaxYear(_response);
      });
  }

  protected processHighQ_GetConsentedTaxYear(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * Get Clients from CEM by SearchTerm
   * @param searchTerm (optional)
   */
  cEM_CEMSearchClients(searchTerm: string | undefined, signal?: AbortSignal): Promise<CEMClientDTO[]> {
    let url_ = this.baseUrl + "/api/v1/Cem/clients/search?";
    if (searchTerm === null) throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined) url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_CEMSearchClients(_response);
      });
  }

  protected processCEM_CEMSearchClients(response: Response): Promise<CEMClientDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMClientDTO[]);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMClientDTO[]>(null as any);
  }

  cem_SyncCEMProcess(siteId: number | undefined, userName: string | undefined, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/Cem/SyncCEMProcess?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCem_SyncCEMProcess(_response);
      });
  }

  protected processCem_SyncCEMProcess(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  tim_Projects(
    siteId: number,
    offset: number | undefined,
    limit: number | undefined,
    isClientView: boolean = false,
    signal?: AbortSignal
  ): Promise<TIM_Projects> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/projects?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ += "isClientView=" + encodeURIComponent("" + !!isClientView) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_Projects(_response);
      });
  }

  protected processTim_Projects(response: Response): Promise<TIM_Projects> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TIM_Projects);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TIM_Projects>(null as any);
  }

  tim_Tasks(
    siteId: number,
    offset: number | undefined,
    limit: number | undefined,
    filter?: TimTasksFilterRequest,
    isClientView: boolean = false,
    signal?: AbortSignal
  ): Promise<TimResponseOfTimTasksResponse> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/tasks?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ += "isClientView=" + encodeURIComponent("" + !!isClientView) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(filter ?? {});

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_Tasks(_response);
      });
  }

  protected processTim_Tasks(response: Response): Promise<TimResponseOfTimTasksResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfTimTasksResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfTimTasksResponse>(null as any);
  }

  tim_Deliverables(
    siteId: number,
    projectIdMdm: number,
    projectIdTim: number | undefined,
    offset: number | undefined,
    limit: number | undefined,
    isClientView: boolean = false,
    signal?: AbortSignal
  ): Promise<TimResponseOfDeliverableResponse> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/project/{projectIdMdm}/deliverables?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (projectIdMdm === undefined || projectIdMdm === null)
      throw new Error("The parameter 'projectIdMdm' must be defined.");
    url_ = url_.replace("{projectIdMdm}", encodeURIComponent("" + projectIdMdm));
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ += "isClientView=" + encodeURIComponent("" + !!isClientView) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        "X-Project-Id-Tim": projectIdTim !== undefined && projectIdTim !== null ? "" + projectIdTim : "",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_Deliverables(_response);
      });
  }

  protected processTim_Deliverables(response: Response): Promise<TimResponseOfDeliverableResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfDeliverableResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfDeliverableResponse>(null as any);
  }

  tim_Entities(
    siteId: number,
    projectIdMdm: number,
    projectIdTim: number | undefined,
    offset: number | undefined,
    limit: number | undefined,
    isClientView: boolean = false,
    signal?: AbortSignal
  ): Promise<TimResponseOfEntitiesResponse> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/project/{projectIdMdm}/entities?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (projectIdMdm === undefined || projectIdMdm === null)
      throw new Error("The parameter 'projectIdMdm' must be defined.");
    url_ = url_.replace("{projectIdMdm}", encodeURIComponent("" + projectIdMdm));
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ += "isClientView=" + encodeURIComponent("" + !!isClientView) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        "X-Project-Id-Tim": projectIdTim !== undefined && projectIdTim !== null ? "" + projectIdTim : "",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_Entities(_response);
      });
  }

  protected processTim_Entities(response: Response): Promise<TimResponseOfEntitiesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfEntitiesResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfEntitiesResponse>(null as any);
  }

  tim_ProjectsCustomizationDataUpdate(
    requestData: ProjectsCustomizationDataRequestDto,
    signal?: AbortSignal
  ): Promise<MessageResultDto> {
    let url_ = this.baseUrl + "/api/v1/site/project/projectscustomizationdata";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestData);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_ProjectsCustomizationDataUpdate(_response);
      });
  }

  protected processTim_ProjectsCustomizationDataUpdate(response: Response): Promise<MessageResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDto>(null as any);
  }

  tim_ProjectsCustomizationStatus(
    siteId: number,
    signal?: AbortSignal
  ): Promise<TimResponseGenericObject<ProjectsCustomizationStatusDto[]>> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/project/projectscustomizationstatus";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_ProjectsCustomizationStatus(_response);
      });
  }

  protected processTim_ProjectsCustomizationStatus(
    response: Response
  ): Promise<TimResponseGenericObject<ProjectsCustomizationStatusDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseGenericObject<
              ProjectsCustomizationStatusDto[]
            >);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseGenericObject<ProjectsCustomizationStatusDto[]>>(null as any);
  }

  tim_ProjectsCustomizationStatusUpdate(
    requestData: ProjectsCustomizationStatusRequestDto,
    signal?: AbortSignal
  ): Promise<MessageResultDto> {
    let url_ = this.baseUrl + "/api/v1/site/project/projectscustomizationstatus";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestData);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_ProjectsCustomizationStatusUpdate(_response);
      });
  }

  protected processTim_ProjectsCustomizationStatusUpdate(response: Response): Promise<MessageResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDto>(null as any);
  }

  tim_Message(
    siteId: number,
    projectIdMdm: number,
    signal?: AbortSignal
  ): Promise<TimResponseOfTimProjectMessagesResponse> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/project/{projectIdMdm}/message";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (projectIdMdm === undefined || projectIdMdm === null)
      throw new Error("The parameter 'projectIdMdm' must be defined.");
    url_ = url_.replace("{projectIdMdm}", encodeURIComponent("" + projectIdMdm));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_Message(_response);
      });
  }

  protected processTim_Message(response: Response): Promise<TimResponseOfTimProjectMessagesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfTimProjectMessagesResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfTimProjectMessagesResponse>(null as any);
  }

  tim_CreateMessage(requestData: TimProjectMessageRequest, signal?: AbortSignal): Promise<TimResponseOfObject> {
    let url_ = this.baseUrl + "/api/v1/site/project/message";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestData);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_CreateMessage(_response);
      });
  }

  protected processTim_CreateMessage(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  tim_UpdateMessage(requestData: TimProjectMessageRequest, signal?: AbortSignal): Promise<TimResponseOfObject> {
    let url_ = this.baseUrl + "/api/v1/site/project/message";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestData);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_UpdateMessage(_response);
      });
  }

  protected processTim_UpdateMessage(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  tim_DeleteMessage(requestData: TimProjectMessageRequest, signal?: AbortSignal): Promise<TimResponseOfObject> {
    let url_ = this.baseUrl + "/api/v1/site/project/message";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestData);

    let options_: RequestInit = {
      body: content_,
      method: "DELETE",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_DeleteMessage(_response);
      });
  }

  protected processTim_DeleteMessage(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  tim_GetProjectVisibilty(siteId: number | undefined, signal?: AbortSignal): Promise<TimResponseOfObject> {
    let url_ = this.baseUrl + "/api/v1/site/ShowProjects?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_GetProjectVisibilty(_response);
      });
  }

  protected processTim_GetProjectVisibilty(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  tim_UpdateProjectVisibilty(
    siteId: number | undefined,
    showProjects: boolean,
    signal?: AbortSignal
  ): Promise<TimResponseOfObject> {
    if (siteId === null || siteId === undefined) throw new Error("The parameter 'siteId' cannot be null or undefined.");
    if (showProjects === null || showProjects === undefined)
      throw new Error("The parameter 'showProjects' cannot be null or undefined.");

    let url_ = this.baseUrl + "/api/v1/site/ShowProjects/" + encodeURIComponent("" + siteId);

    const content_ = JSON.stringify({ showProjects: showProjects });

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_UpdateProjectVisibilty(_response);
      });
  }

  protected processTim_UpdateProjectVisibilty(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  tim_GetProjectSettings(siteId: number | undefined, signal?: AbortSignal): Promise<TimResponseOfObject> {
    let url_ = this.baseUrl + "/api/v1/site/GetProjectSettingsData?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_GetProjectSettings(_response);
      });
  }

  protected processTim_GetProjectSettings(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  tim_UpdateProjectSettings(
    siteId: number | undefined,
    updatedProjectSettings: ProjectSettingDTO[],
    signal?: AbortSignal
  ): Promise<TimResponseOfObject> {
    let url_ = this.baseUrl + "/api/v1/site/UpdateProjectSettingsData?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(updatedProjectSettings);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_UpdateProjectSettings(_response);
      });
  }

  protected processTim_UpdateProjectSettings(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  tim_FetchProjectCustomizationDataNotes(
    siteId: number | undefined,
    projectIdMdm: number | undefined,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/project/{projectIdMdm}/statusnotes?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (projectIdMdm === undefined || projectIdMdm === null)
      throw new Error("The parameter 'projectIdMdm' must be defined.");
    url_ = url_.replace("{projectIdMdm}", encodeURIComponent("" + projectIdMdm));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_FetchProjectCustomizationDataNotes(_response);
      });
  }

  protected processTim_FetchProjectCustomizationDataNotes(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  tim_GetStatusNotesAndMessage(
    siteId: number,
    projectIdMdm: number,
    signal?: AbortSignal
  ): Promise<NotificationDetailResponse> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/project/{projectIdMdm}/badge";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (projectIdMdm === undefined || projectIdMdm === null)
      throw new Error("The parameter 'projectIdMdm' must be defined.");
    url_ = url_.replace("{projectIdMdm}", encodeURIComponent("" + projectIdMdm));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_GetStatusNotesAndMessage(_response);
      });
  }

  protected processTim_GetStatusNotesAndMessage(response: Response): Promise<NotificationDetailResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as NotificationDetailResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<NotificationDetailResponse>(null as any);
  }

  taxportal_GetSiteProcessExecutionDetails(siteId: string | null, appName: string) {
    let url_ = this.baseUrl + "/api/v1/ProcessExecution/";
    if (siteId === undefined) throw new Error("The parameter 'id' must be defined.");
    if (siteId !== null) url_ += encodeURIComponent("" + siteId) + "/site-process-execution-details?";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName);
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxportal_GetProcessExecutionDetailsStatus(_response);
      });
  }
tim_SearchTerm(
  siteId: number,
  type: string,
  searchValue?: string,
  signal?: AbortSignal
): Promise<TimResponseOfListOfProjectFilter> {
  let url_ = this.baseUrl + "/api/v1/site/{siteId}/search";

  if (siteId === undefined || siteId === null)
    throw new Error("The parameter 'siteId' must be defined.");

  url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));

  if (type === undefined || type === null)
    throw new Error("The parameter 'type' must be defined.");

  url_ += "?type=" + encodeURIComponent("" + type);

  if (searchValue !== undefined && searchValue !== null) {
    url_ += "&searchValue=" + encodeURIComponent("" + searchValue);
  }

  url_ = url_.replace(/[?&]$/, "");

  let options_: RequestInit = {
    method: "POST",
    signal,
    headers: {
      Accept: "application/json",
    },
  };

  return this.transformOptions(options_)
    .then((transformedOptions_) => {
      return this.http.fetch(url_, transformedOptions_);
    })
    .then((_response: Response) => {
      return this.processTim_SearchTerm(_response);
    });
}

protected processTim_SearchTerm(
  response: Response
): Promise<TimResponseOfListOfProjectFilter> {
  const status = response.status;
  let _headers: any = {};

  if (response.headers && response.headers.forEach) {
    response.headers.forEach((v: any, k: any) => (_headers[k] = v));
  }

  if (status === 200) {
    return response.text().then((_responseText) => {
      let result200: any = null;

      result200 =
        _responseText === ""
          ? null
          : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as TimResponseOfListOfProjectFilter);

      return result200;
    });
  } else if (status === 400) {
    return response.text().then((_responseText) => {
      let result400: any = null;

      result400 =
        _responseText === ""
          ? null
          : (JSON.parse(
              _responseText,
              this.jsonParseReviver
            ) as ProblemDetails);

      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400
      );
    });
  } else if (status === 500) {
    return response.text().then((_responseText) => {
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers
      );
    });
  } else if (status !== 200 && status !== 204) {
    return response.text().then((_responseText) => {
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    });
  }

  return Promise.resolve<TimResponseOfListOfProjectFilter>(null as any);
}

  taxPortal_DisassociateLegalEntities(
    selectedEntities: MDMSelectedLegalEntityDTO[],
    siteId: number | undefined,
    appName: string | undefined,
    isAllSiteSelected: boolean | false,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/disassociateLegalEntities?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ += "isAllSiteSelected=" + encodeURIComponent("" + isAllSiteSelected) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(selectedEntities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_DisassociateLegalEntities(_response);
      });
  }

  protected processTaxPortal_DisassociateLegalEntities(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  mDM_UpdateSelectedLegalEntities(
    selectedEntities: MDMSelectedLegalEntityDTO[],
    siteId: number | undefined,
    appName: string | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/client/updatelegalEntities?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(selectedEntities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_UpdateSelectedLegalEntities(_response);
      });
  }

  protected processMDM_UpdateSelectedLegalEntities(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  mDM_CheckSettingsChange(
    selectedEntities: MDMSelectedLegalEntityDTO[],
    siteId: number | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/client/checkSettingsChange?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(selectedEntities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_CheckSettingsChange(_response);
      });
  }

  protected processMDM_CheckSettingsChange(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_ClientMappingDetails(siteId: number, signal?: AbortSignal): Promise<CEMHQClientDTO> {
    let url_ = this.baseUrl + "/api/v1/HqCreateSite/ClientMappingDetails/{siteId}";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ClientMappingDetails(_response);
      });
  }

  protected processTaxPortal_ClientMappingDetails(response: Response): Promise<CEMHQClientDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMHQClientMappingDTO);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMHQClientMappingDTO>(null as any);
  }

  taxPortal_UpdateClientMappingDetails(
    siteId: number,
    clientDTO: CEMHQClientDTO,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/HqCreateSite/UpdateClientMappingDetails/{siteId}";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(clientDTO);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateClientMappingDetails(_response);
      });
  }

  protected processTaxPortal_UpdateClientMappingDetails(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  mDM_GetMDMLegalEntitiesPerSite(
    mdmClientId: number,
    siteId: number | undefined,
    signal?: AbortSignal
  ): Promise<MDMLegalEntityResponse> {
    let url_ = this.baseUrl + "/api/v1/Mdm/client/{mdmClientId}/legalEntitiesPerSite?";
    if (mdmClientId === undefined || mdmClientId === null)
      throw new Error("The parameter 'mdmClientId' must be defined.");
    url_ = url_.replace("{mdmClientId}", encodeURIComponent("" + mdmClientId));
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_GetMDMLegalEntitiesPerSite(_response);
      });
  }

  protected processMDM_GetMDMLegalEntitiesPerSite(response: Response): Promise<MDMLegalEntityResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MDMLegalEntityResponse);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MDMLegalEntityResponse>(null as any);
  }

  taxportal_UpdateTask(siteId: number, payload: TimTaskUpdateRequest, signal?: AbortSignal) {
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/tasks";
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(payload);
    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxportal_UpdateTask(_response);
      });
  }

  protected processTaxportal_UpdateTask(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};

    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }

    return Promise.resolve<any>(null as any);
  }
  mDM_GetSelectedLegalEntities(
    siteId: number | undefined,
    mdmClientId: number | undefined,
    signal?: AbortSignal
  ): Promise<GetMDMEntityListResponse> {
    let url_ = this.baseUrl + "/api/v1/Mdm/client/selectedLegalEntities?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (mdmClientId === null) throw new Error("The parameter 'mdmClientId' cannot be null.");
    else if (mdmClientId !== undefined) url_ += "mdmClientId=" + encodeURIComponent("" + mdmClientId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_GetSelectedLegalEntities(_response);
      });
  }

  protected processMDM_GetSelectedLegalEntities(response: Response): Promise<GetMDMEntityListResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<any>(null as any);
  }

  site_UpdateExclude7216Settings(
    siteId: number | undefined,
    exclude7216ConsentValue: boolean | undefined,
    username: string | undefined,
    isPDCEnabled: boolean,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/UpdateSiteConsentByExclude7216Settings";
    url_ = url_.replace(/[?&]$/, "");

    if (siteId === null || siteId === undefined) throw new Error("The parameter 'siteId' cannot be null.");
    if (exclude7216ConsentValue === null || exclude7216ConsentValue === undefined)
      throw new Error("The parameter 'exclude7216ConsentValue' cannot be null.");
    if (username === null || username === undefined) throw new Error("The parameter 'username' cannot be null.");

    const requestBody = {
      siteId: siteId,
      exclude7216Consent: exclude7216ConsentValue,
      isPDCEnabled,
      userName: username,
    };

    const content_ = JSON.stringify(requestBody);
    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSite_UpdateExclude7216Settings(_response);
      });
  }

  protected processSite_UpdateExclude7216Settings(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_GetHQSiteSettings(): Promise<GetSiteSettingsDTO[]> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/HQSitesSettings";
    url_ = url_.replace(/[?&]$/, "");
    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetHQSiteSettings(_response);
      });
  }
  protected processTaxPortal_GetHQSiteSettings(response: Response): Promise<GetSiteSettingsDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSiteSettingsDTO[]);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSiteSettingsDTO[]>(null as any);
  }
  /**
   * Get all active HQSiteSettings details
   * @return List of HQSitesSettings
   */
  taxPortal_GetHQSitesSettings(signal?: AbortSignal): Promise<HQSitesSettingDTO[]> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/HQSitesSettings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetHQSitesSettings(_response);
      });
  }

  protected processTaxPortal_GetHQSitesSettings(response: Response): Promise<HQSitesSettingDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQSitesSettingDTO[]);
        return result200.data;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "Request was success but no Active HQ SitesSetting records present",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Badrequest", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQSitesSettingDTO[]>(null as any);
  }

  taxPortal_UpdateHQSitesSettingsBySiteId(
    siteId: number,
    settings: HQSitesSettingDTO[],
    username: string,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/HQSitesSettings/{siteId}";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(settings);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        userName: username,
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateHQSitesSettingsBySiteId(_response);
      });
  }

  protected processTaxPortal_UpdateHQSitesSettingsBySiteId(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result: any = null;
        result = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result?.data ?? result;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Not found", status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }
  /**
   * Create Active HQSettings
   * @param userName (optional)
   * @return Site Setting added successfully and returns Id
   */
  taxPortal_CreateHQSitesSettings(
    userName: string | undefined,
    hQSitesSettings: HQSitesSettingDTO[],
    signal?: AbortSignal
  ): Promise<CreateSitesSettingIdDTO[]> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/HQSitesSettings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(hQSitesSettings);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        userName: userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_CreateHQSitesSettings(_response);
      });
  }

  protected processTaxPortal_CreateHQSitesSettings(response: Response): Promise<CreateSitesSettingIdDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CreateSitesSettingIdDTO[]);
        return result201?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Badrequest", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQSitesSettingDTO[]);
        return throwException(
          "HQSiteSetting Conflict returns Conflicted setting",
          status,
          _responseText,
          _headers,
          result409
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CreateSitesSettingIdDTO[]>(null as any);
  }

  /**
   * Update Active HQSettings
   * @param id Sites Setting id
   * @param userName (optional) User name
   * @param hQSitesSettings Sites Setting with updated values
   * @return Site Setting updated successfully and returns No Content
   */

  taxPortal_UpdateHQSitesSettings(
    id: number,
    userName: string | undefined,
    hQSitesSettings: HQSitesSettingDTO[],
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/HQSitesSettings/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(hQSitesSettings);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        userName: userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateHQSitesSettings(_response);
      });
  }

  protected processTaxPortal_UpdateHQSitesSettings(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Badrequest", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Not found", status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Delete sites setting for given id
   * @param id site setting id
   * @return Site Setting Deleted
   */
  taxPortal_DeleteHQSitesSetting(id: number, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/HQSitesSettings/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_DeleteHQSitesSetting(_response);
      });
  }

  protected processTaxPortal_DeleteHQSitesSetting(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Badrequest", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("HQSitesSettings not available", status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  taxPortal_AddSiteComments(
    api_version: string | null | undefined,
    site: ServiceMessage,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/AddSiteComments?";
    if (api_version !== undefined && api_version !== null)
      url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(site);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_AddSiteComments(_response);
      });
  }

  protected processTaxPortal_AddSiteComments(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_GetAllSiteSearch(
    type: SyncTypeEnum | undefined,
    appName: string | null | undefined,
    searchTerm: string | null | undefined,
    isSiteComment?: boolean | null,
    isCustomPermission?: boolean | null,
    signal?: AbortSignal
  ): Promise<GetAllSitesResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/AllSiteSearch?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (isSiteComment !== undefined && isSiteComment !== null)
      url_ += "isSiteComment=" + encodeURIComponent("" + isSiteComment) + "&";
    if (isCustomPermission !== undefined && isCustomPermission !== null)
      url_ += "isCustomPermission=" + encodeURIComponent("" + isCustomPermission) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetAllSiteSearch(_response);
      });
  }

  protected processTaxPortal_GetAllSiteSearch(response: Response): Promise<GetAllSitesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesResponse);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesResponse>(null as any);
  }

  taxPortal_GetSiteSettingAllSitesSearch(
    type: SyncTypeEnum | undefined,
    appName: string | null | undefined,
    searchTerm: string | null | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSitesResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/siteSettingAllSiteSearch?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetSiteSettingAllSitesSearch(_response);
      });
  }

  protected processTaxPortal_GetSiteSettingAllSitesSearch(response: Response): Promise<GetAllSitesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesResponse);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesResponse>(null as any);
  }

  taxPortal_GetAllSites(
    type: SyncTypeEnum | undefined,
    userName: string | null | undefined,
    appName: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    isSiteComment?: boolean | null,
    isCustomPermission?: boolean | null,
    signal?: AbortSignal
  ): Promise<GetAllSitesResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/allSites?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (userName !== undefined && userName !== null) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (isSiteComment !== undefined && isSiteComment !== null)
      url_ += "isSiteComment=" + encodeURIComponent("" + isSiteComment) + "&";
    if (isCustomPermission !== undefined && isCustomPermission !== null)
      url_ += "isCustomPermission=" + encodeURIComponent("" + isCustomPermission) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetAllSites(_response);
      });
  }

  protected processTaxPortal_GetAllSites(response: Response): Promise<GetAllSitesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesResponse);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesResponse>(null as any);
  }

  taxPortal_GetSiteSettingAllSites(
    type: SyncTypeEnum | undefined,
    userName: string | null | undefined,
    appName: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSitesResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteSettings/siteSettingAllSites?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (userName !== undefined && userName !== null) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetSiteSettingAllSites(_response);
      });
  }

  protected processTaxPortal_GetSiteSettingAllSites(response: Response): Promise<GetAllSitesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesResponse);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesResponse>(null as any);
  }
  highQ_ModifySiteName(
    siteId: number | undefined,
    siteDetails: AddMDMSelectedLegalEntityDTO[],
    appName: string | undefined,
    signal?: AbortSignal
  ): Promise<string[]> {
    let url_ = this.baseUrl + "/api/v1/HqCreateSite/ModifySiteName?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteDetails);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_ModifySiteName(_response);
      });
  }

  protected processHighQ_ModifySiteName(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
        return result200?.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string[]>(null as any);
  }

  taxPortal_InsertUpdateSiteSettings(
    userName: string,
    method: string,
    body: { data?: GetSiteSettingsDTO[]; id?: string }
  ): Promise<string> {
    const endpoint = method !== "POST" ? `HQSitesSettings/${body.id}` : "HQSitesSettings";
    let url_ = this.baseUrl + `/api/v1/SiteCreation/${endpoint}`;
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined and cannot be null.");
    url_ = url_.replace(/[?&]$/, "");

    const content_ = method !== "DELETE" ? JSON.stringify(body.data) : null;

    let options_: RequestInit = {
      body: content_,
      method: method,
      headers: {
        userName: userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxPortal_InsertUpdateSiteSettings(_response);
      });
  }
  protected processtaxPortal_InsertUpdateSiteSettings(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 201) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        const response = JSON.parse(_responseText);
        return throwException("Conflicts with files.", status, response, _headers);
      });
    } else if (status !== 200 && status !== 201 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }

    return Promise.resolve<string>(null as any);
  }
  taxPortal_GetSiteComments(
    siteId: number | null | undefined,
    api_version: string | null | undefined,
    signal?: AbortSignal
  ): Promise<GetSiteCommentsDTO[]> {
    let url_ = this.baseUrl + "/api/v1/HqCreateSite/GetSiteComments?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (api_version !== undefined && api_version !== null)
      url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetSiteComments(_response);
      });
  }

  protected processTaxPortal_GetSiteComments(response: Response): Promise<GetSiteCommentsDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSiteCommentsDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSiteCommentsDTO[]>(null as any);
  }

  highQ_GetHQSiteTemplate(
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<SiteCreationTemplatesDto[]> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/GetSiteTemplates?";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetHQSiteTemplate(_response);
      });
  }

  protected processHighQ_GetHQSiteTemplate(response: Response): Promise<SiteCreationTemplatesDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SiteCreationTemplatesDto[]);
        return result200.data;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SiteCreationTemplatesDto[]>(null as any);
  }

  siteSetUp_SiteSetUp(message: SiteCreationMessage, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/siteSetUp/SiteSetUp";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(message);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteSetUp_SiteSetUp(_response);
      });
  }

  protected processSiteSetUp_SiteSetUp(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200?.data ?? result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not found.", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxportal_ExportSelectedSitesToExcel(selectedSites: siteDetailDTO[]): Promise<ArrayBuffer> {
    let url_ = this.baseUrl + "/dl/v1/FileProcess/DownloadBulkCreationSites";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(selectedSites);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processtaxportal_ExportSelectedSitesToExcel(_response);
      });
  }

  protected processtaxportal_ExportSelectedSitesToExcel(response: Response): Promise<ArrayBuffer> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.arrayBuffer().then((arrayBuffer) => {
        return arrayBuffer;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ArrayBuffer>(null as any);
  }

  tim_GetSiteUsers(siteId: number, signal?: AbortSignal): Promise<TimResponseOfListOfTaggedUser> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/siteusers";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_GetSiteUsers(_response);
      });
  }

  protected processTim_GetSiteUsers(response: Response): Promise<TimResponseOfListOfTaggedUser> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfListOfTaggedUser);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfListOfTaggedUser>(null as any);
  }

  tim_ResetProjectSettings(siteId: number | undefined, signal?: AbortSignal): Promise<TimResponseOfObject> {
    let url_ = this.baseUrl + "/api/v1/site/ResetProjectSettings?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_ResetProjectSettings(_response);
      });
  }

  protected processTim_ResetProjectSettings(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }



  tim_FilterEntity(
    siteId: number,
    searchTerm?: string | null,
    signal?: AbortSignal
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/tasks/filter/entity?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (searchTerm !== undefined && searchTerm !== null) url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_FilterEntity(_response);
      });
  }

  protected processTim_FilterEntity(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<any>(null as any);
  }

  tim_FilterStage(
    siteId: number,
    searchTerm?: string | null,
    signal?: AbortSignal
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/tasks/filter/stage?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (searchTerm !== undefined && searchTerm !== null) url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_FilterStage(_response);
      });
  }

  protected processTim_FilterStage(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<any>(null as any);
  }

  tim_FilterProject(
    siteId: number,
    searchTerm?: string | null,
    signal?: AbortSignal
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/v1/site/{siteId}/tasks/filter/project?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (searchTerm !== undefined && searchTerm !== null) url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTim_FilterProject(_response);
      });
  }

  protected processTim_FilterProject(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as any);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<any>(null as any);
  }

  tim_UpdateTaskVisibility(
    requestData: { hqSiteId: number; projectsCustomizationData: Array<{ projectIdMDM: number; taskId: number; isHidden: boolean }> },
    signal?: AbortSignal
  ): Promise<TimResponseOfObject> {
    const url_ = this.baseUrl + "/api/v1/site/project/taskvisibility";
    const content_ = JSON.stringify(requestData);
    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => this.http.fetch(url_, transformedOptions_))
      .then((_response: Response) => this.processTim_UpdateTaskVisibility(_response));
  }

  protected processTim_UpdateTaskVisibility(response: Response): Promise<TimResponseOfObject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimResponseOfObject);
        return result200;
      });
    } else if (status === 400 || status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TimResponseOfObject>(null as any);
  }

  hqCreateFolder_SyncFolderCreation(message: SiteCreationRequestMessage, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/HqCreateFolder/SyncFolderCreation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(message);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqCreateFolder_SyncFolderCreation(_response);
      });
  }

  protected processHqCreateFolder_SyncFolderCreation(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  hqCreateFolder_SyncFolderCreationIndividualFolder(
    message: SiteCreationRequestMessage,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/HqCreateFolder/SyncFolderCreationIndividualFolder";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(message);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqCreateFolder_SyncFolderCreationIndividualFolder(_response);
      });
  }

  protected processHqCreateFolder_SyncFolderCreationIndividualFolder(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  hqCreateFolder_CreateFolderWithPermissionsAndMetadata(
    siteId: number | undefined,
    userName: string | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/HqCreateFolder/CreateFolderWithPermissionsAndMetadata?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqCreateFolder_CreateFolderWithPermissionsAndMetadata(_response);
      });
  }

  protected processHqCreateFolder_CreateFolderWithPermissionsAndMetadata(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  hqProjectStatus_SyncProjectStatus(messaage: SiteCreationRequestMessage, signal?: AbortSignal): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/HqProjectStatus/SyncProjectStatus";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messaage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqProjectStatus_SyncProjectStatus(_response);
      });
  }

  protected processHqProjectStatus_SyncProjectStatus(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  hqProjectStatus_UpdateProjectStatus(
    siteId: number | undefined,
    userName: string | undefined,
    signal?: AbortSignal
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/HqProjectStatus/UpdateProjectStatus?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqProjectStatus_UpdateProjectStatus(_response);
      });
  }

  protected processHqProjectStatus_UpdateProjectStatus(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  thirdPartyOrganization_PopulateThirdPartyOrganization(
    siteCreationMessage: SiteCreationRequestMessage,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/ThirdPartyOrganization/PopulateThirdPartyOrganization";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteCreationMessage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processThirdPartyOrganization_PopulateThirdPartyOrganization(_response);
      });
  }

  protected processThirdPartyOrganization_PopulateThirdPartyOrganization(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  thirdPartyOrganization_SyncPopulateThirdPartyOrganization(
    siteId: number | undefined,
    userName: string | undefined,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/ThirdPartyOrganization/SyncPopulateThirdPartyAndMemberFirmOrganization?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processThirdPartyOrganization_SyncPopulateThirdPartyOrganization(_response);
      });
  }

  protected processThirdPartyOrganization_SyncPopulateThirdPartyOrganization(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  isheetReport_UpdateISheetReportStats(
    siteId: number | undefined,
    iSheetName: string | undefined,
    userName: string | undefined,
    signal?: AbortSignal
  ): Promise<IsheetReportDto> {
    let url_ = this.baseUrl + "/api/v1/IsheetReport/UpdateISheetReportStats?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (iSheetName === null) throw new Error("The parameter 'iSheetName' cannot be null.");
    else if (iSheetName !== undefined) url_ += "iSheetName=" + encodeURIComponent("" + iSheetName) + "&";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processIsheetReport_UpdateISheetReportStats(_response);
      });
  }

  protected processIsheetReport_UpdateISheetReportStats(response: Response): Promise<IsheetReportDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as IsheetReportDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<IsheetReportDto>(null as any);
  }


  dashboard_GetISheetItemsByType(
    siteId: number | null | undefined,
    isheetType: string | null | undefined,
    userName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<any[]> {
    let url_ = this.baseUrl + "/api/v1/Dashboard/GetISheetItemsByType?";

    //if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (siteId !== undefined && siteId !== null && siteId !== 0) {
      url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    }
    if (isheetType !== undefined && isheetType !== null)
      url_ += "iSheetName=" + encodeURIComponent("" + isheetType) + "&";
    if (userName !== undefined && userName !== null) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDashboard_GetISheetItemsByType(_response);
      });
  }
  protected processDashboard_GetISheetItemsByType(response: Response): Promise<any[]> {
    const status = response.status;

    let _headers: any = {};

    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    if (status === 200) {
      return response.text().then((_responseText) => {
        const result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);

        // API may return either an array directly or a wrapped response with data.
        if (Array.isArray(result200)) {
          return result200;
        }

        if (result200 && Array.isArray(result200.data)) {
          return result200.data;
        }

        return [];
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;

        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);

        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }

    return Promise.resolve<any[]>([]);
  }

  dashboard_BuildRedirectUrl(request: ISheetItemRedirectRequest): Promise<string> {
    if (request === undefined || request === null) throw new Error("The parameter 'request' must be defined.");
    console.log("Request object:", request);
    // ✅ Fixed URL — points to the correct endpoint
    let url_ = this.baseUrl + "/api/v1/Dashboard/BuildRedirectUrl";

    let options_: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(request), // ✅ Sends the full request object
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDashboard_BuildRedirectUrl(_response);
      });
  }

  protected processDashboard_BuildRedirectUrl(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    if (status === 200) {
      return response.text().then((_responseText) => {
        const result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);

        // API may return a string URL, an object with URL fields, or wrapped data.
        if (typeof result200 === "string") {
          return result200;
        }

        if (Array.isArray(result200)) {
          return result200;
        }

        if (result200 && typeof result200 === "object" && "data" in result200) {
          const data = (result200 as any).data;
          if (typeof data === "string") {
            return data;
          }
          if (Array.isArray(data)) {
            return data;
          }
          if (data && typeof data === "object") {
            return data;
          }
        }

        if (result200 && typeof result200 === "object") {
          return result200;
        }

        return null;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad request.", status, _responseText, _headers);
      });
    } else if (status === 404) {
      // ✅ Added 404 handler to match controller's NotFound()
      return response.text().then((_responseText) => {
        return throwException("Unable to generate navigation URL.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }

    return Promise.resolve<string>("");
  }

  syncisheetitems_ISheetName(
    siteId: number | null | undefined,
    isheetType: string | null | undefined,
    userName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/v1/SyncISheetItems/ISheetName?";

    if (siteId !== undefined && siteId !== null && siteId !== 0) {
      url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    }
    if (isheetType !== undefined && isheetType !== null)
      url_ += "iSheetName=" + encodeURIComponent("" + isheetType) + "&";

    if (userName !== undefined && userName !== null) url_ += "userName=" + encodeURIComponent("" + userName) + "&";

    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSyncISheetItems_ISheetName(_response);
      });
  }
  protected processSyncISheetItems_ISheetName(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};

    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    if (status === 200) {
      return response.text().then((_responseText) => {
        if (_responseText === "") return null;

        const result200 = JSON.parse(_responseText, this.jsonParseReviver);

        // Unwrap standard envelope { statusCode, message, data }
        const data = result200?.data ?? result200;

        // Empty object or null/undefined → return null
        if (!data || (typeof data === "object" && Object.keys(data).length === 0)) {
          return null;
        }

        return data; // string URL or populated object
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        const result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }

    return Promise.resolve<any>(null);
  }

  mDM_ExportToExcelForLegalEntitiesHistory(
    siteId: number | undefined,
    appName: string | undefined,
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/dl/v1/SiteCreation/ExportToExcellegalEntitiesHistory?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processmDM_ExportToExcelForLegalEntitiesHistory(_response);
      });
  }

  protected processmDM_ExportToExcelForLegalEntitiesHistory(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  taxportalDbData_GetCreateSiteTrackDetails(
    status: string | null | undefined,
    siteId: number | null | undefined,
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSitesResponse> {
    let url_ = this.baseUrl + "/api/v1/TaxPortalDbData/GetCreateSiteTrackDetails?";
    if (status !== undefined && status !== null) url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetCreateSiteTrackDetails(_response);
      });
  }

  protected processHighQ_GetCreateSiteTrackDetails(response: Response): Promise<GetAllSitesFromTrackResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesFromTrackResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesResponse>(null as any);
  }

  taxportalDbData_GetItemSyncTrackByType(
    siteId: number | null | undefined,
    type: string | null | undefined,
    userName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<ItemSyncTrackDto> {
    let url_ = this.baseUrl + "/api/v1/TaxPortalDbData/GetItemSyncTrackByType?";
    //if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (siteId !== undefined && siteId !== null && siteId !== 0) {
      url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    }
    if (type !== undefined && type !== null) url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (userName !== undefined && userName !== null) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxportalDbData_GetItemSyncTrackByType(_response);
      });
  }

  protected processTaxportalDbData_GetItemSyncTrackByType(response: Response): Promise<ItemSyncTrackDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ItemSyncTrackDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ItemSyncTrackDto>(null as any);
  }

  hqFolder_AssignFolderPermissions(
    siteCreationMessage: SiteCreationRequestMessage,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/HqFolder/AssignFolderPermissions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteCreationMessage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqFolder_AssignFolderPermissions(_response);
      });
  }

  protected processHqFolder_AssignFolderPermissions(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hqFolder_UpdateFolderMetadata(siteCreationMessage: SiteCreationRequestMessage, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/HqFolder/UpdateFolderMetadata";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteCreationMessage);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqFolder_UpdateFolderMetadata(_response);
      });
  }

  protected processHqFolder_UpdateFolderMetadata(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hqFolder_GetWorkspaces(
    siteId: number,
    clientId: string | null | undefined,
    workspaceId: string | null | undefined,
    isSource: boolean | undefined,
    signal?: AbortSignal
  ): Promise<DocumentTreeResponseDTO> {
    let url_ = this.baseUrl + "/api/v1/HqFolder/workspaces/{siteId}?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (clientId !== undefined && clientId !== null) url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
    if (workspaceId !== undefined && workspaceId !== null)
      url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
    if (isSource !== undefined && isSource !== null) url_ += "isSource=" + encodeURIComponent("" + isSource) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqFolder_GetWorkspaces(_response);
      });
  }

  protected processHqFolder_GetWorkspaces(response: Response): Promise<DocumentTreeResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DocumentTreeResponseDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<DocumentTreeResponseDTO>(null as any);
  }

  hqFolder_GetFoldersBySiteId(
    siteId: number,
    isSource: boolean | undefined,
    signal?: AbortSignal
  ): Promise<DocumentTreeResponseDTO> {
    let url_ = this.baseUrl + "/api/v1/HqFolder/HQfoldersAndFiles/{siteId}?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (isSource === null) throw new Error("The parameter 'isSource' cannot be null.");
    else if (isSource !== undefined) url_ += "isSource=" + encodeURIComponent("" + isSource) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHqFolder_GetFoldersBySiteId(_response);
      });
  }

  protected processHqFolder_GetFoldersBySiteId(response: Response): Promise<DocumentTreeResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DocumentTreeResponseDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<DocumentTreeResponseDTO>(null as any);
  }

  iManageWorkspace_RefreshEntityImanage(
    siteId: number | undefined,
    isForceUpdate: boolean | undefined,
    target?: string | null,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/ImanageWorkspace/RefreshEntityImanage?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (target !== undefined && target !== null) url_ += "refreshTarget=" + encodeURIComponent("" + target) + "&";
    if (isForceUpdate === null) throw new Error("The parameter 'isForceUpdate' cannot be null.");
    else if (isForceUpdate !== undefined) url_ += "IsForceUpdate=" + encodeURIComponent("" + isForceUpdate) + "&";

    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processIManageWorkspace_RefreshEntityImanage(_response);
      });
  }

  protected processIManageWorkspace_RefreshEntityImanage(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  pdc_UpdatePDCConfiguration(
    hQSitesSetting: PdcConfiguration[] | undefined,
    appName: string,
    userName: string
  ): Promise<PdcConfigurationUpdateResult> {
    let url_ = `${this.baseUrl}/api/v1/SiteCreation/UpdatePDCConfiguration?`;
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(hQSitesSetting);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        userName: userName,
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPdc_UpdatePDCConfiguration(_response);
      });
  }

  protected processPdc_UpdatePDCConfiguration(response: Response): Promise<PdcConfigurationUpdateResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {      
      return response.text().then((_responseText) => {
        let result200: PdcConfigurationUpdateResult = null as any;
        result200 = _responseText === "" ? (null as any) : JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<PdcConfigurationUpdateResult>(null as any);
  } 

  pdc_GetLegalEntityPdcDuoConfig(
    siteId: number
  ): Promise<PdcSiteLegalEntityMappingResponse> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/GetSiteLegalEntityPdcDuoConfig?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.process_GetLegalEntityPdcDuoConfig(_response);
      });
  }
  
  protected process_GetLegalEntityPdcDuoConfig(response: Response): Promise<PdcSiteLegalEntityMappingResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PdcSiteLegalEntityMappingResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<PdcSiteLegalEntityMappingResponse>(null as any);
  }

  pdc_SaveLegalEntityPdcDuoConfig(entities: PdcSiteLegalEntityMapping, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/SiteCreation/SaveSiteLegalEntityPdcDuoConfig";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(entities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPdc_SaveLegalEntityPdcDuoConfig(_response);
      });
  }

  protected processPdc_SaveLegalEntityPdcDuoConfig(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
